import { fetchUserTier } from './fetchUserTier';

export enum SubscriptionType {
  GOLD_OLD = 'gold_old',
  PRO = 'pro',
  MAX_STARTER = 'max_starter',
  MAX_PERFORMANCE = 'max_performance',
}

const proSubscriptions = [
  SubscriptionType.GOLD_OLD,
  SubscriptionType.PRO,
  SubscriptionType.MAX_STARTER,
  SubscriptionType.MAX_PERFORMANCE,
];

const isProUser = async (): Promise<boolean> => {
  const userTier = await fetchUserTier();

  const userSubscriptionType = userTier?.response?.id;
  if (!userSubscriptionType) return false;
  return proSubscriptions.includes(userSubscriptionType as SubscriptionType);
};

export { isProUser };
